import {AppIdentifiers, IOpenAppData} from '@sparkware/uc-sdk-core';

export const CASINOFIED_APP_INIT_TIMEOUT_MS = 10000;

export interface ICasinofiedApplication {
    readonly appId: AppIdentifiers;
    readonly isMinimized: boolean;
    readonly isLoading: boolean;
    readonly openAppData: IOpenAppData;
    open(): Promise<void>;
    minimize(appData: any): void;
    maximize(): void;
    dispose(): void;
    readonly isDisposed: boolean;
    waitForAppToOpen(): Promise<void>;
    isOpeningInNewWindow(): boolean;
}
